import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=fddb8952&scoped=true"
import script from "./fail.vue?vue&type=script&lang=js"
export * from "./fail.vue?vue&type=script&lang=js"
import style0 from "./fail.vue?vue&type=style&index=0&id=fddb8952&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddb8952",
  null
  
)

export default component.exports